module.exports = __webpack_public_path__ + "static/facebook-a04913d21b0ca86d99bfe6347cc547e0.png";